import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Home from "./views/Home";
import ModelDetail from "./views/ModelDetail";
import ModelDetailNew from "./views/ModelDetailNew";
import Dealerships from "./views/Dealerships";
import Confirmation from "./views/Confirmation";
import { ConfiguratorProvider } from "./context";

const App = ({ basename, version, accessories }) => {
    return (
        <BrowserRouter basename={basename}>
            <ConfiguratorProvider version={version} accessories={accessories} basename={basename}>
                <Switch>
                    <Route exact path="/" component={Home} />
                    {version === "v1" ? (
                        <Route path="/configurar/:version_id" component={ModelDetail}></Route>
                    ) : (
                        <Route path="/configurar/:version_id" component={ModelDetailNew}></Route>
                    )}
                    {/* <Route path="/concesionarias" component={Dealerships} /> */}
                    {/* <Route path="/confirmacion" component={Confirmation} /> */}
                    <Route path="*">
                        <Redirect to="/" />
                    </Route>
                </Switch>
            </ConfiguratorProvider>
        </BrowserRouter>
    );
};

export default App;
